import EmberService, { service } from '@ember/service';

import type { Editor as TinymceEditor } from 'tinymce';

import type { PopupListItem, Service } from 'webapp-types';

import type TeamsTextComponent from 'webapp/components/teams/text';

export type Action = 'removeFromSection';
export type Option = PopupListItem<Action>;

export default class TeamService extends EmberService {
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('model-manager/team-sections')
	declare mmTeamSectionsService: Service.ModelManager.TeamSections;
	@service('model-manager/team-section-items')
	declare mmTeamSectionItemsService: Service.ModelManager.TeamSectionItems;
	@service('request') declare requestService: Service.Request;

	getEditorOptions(component: TeamsTextComponent, isReadOnly = false, placeholder?: string) {
		return {
			placeholder,
			readonly: isReadOnly,
			toolbar: [
				{ name: 't2', items: ['bold', 'italic', 'underline'] },
				{ name: 't4', items: ['bullist', 'numlist'] },
				{ name: 't5', items: ['link'] },
			],
			onSetup: (__smth: unknown, editor: TinymceEditor) => {
				component.editor = editor;

				//update also on keyup
				editor.on('keyup', () => {
					const content = editor.getContent();
					component.onChange(content);
				});
			},
		};
	}

	getTeamSectionItemOptions(isVisible: boolean): Option[] {
		const options: Option[] = [];

		if (isVisible) {
			options.push({
				icon: 'Close',
				text: 'Remove from section',
				action: 'removeFromSection',
			});
		}

		return options;
	}
}

declare module '@ember/service' {
	interface Registry {
		team: TeamService;
	}
}
